import { words, upperFirst } from 'lodash'

export const titleCase = (str: string) => words(str).map(upperFirst).join(' ')

export function splitCamelCase(input: string) {
  return input.replace(/([a-z])([A-Z])/g, '$1 $2')
}
